// Mapa de categorias de proyectos, compartido por el navbar (secciones) y por
// las etiquetas de las tarjetas de la Home. Los valores son el campo `id` de
// cada Project declarado en services/webService.js.
//
// Games: GameShips(0), AircraftWar(1), SpermaGame(2), EspantaChiringuitos(5), SpermGame2(8), MasterPanic(10), ThieveOS(11), MathBubbleShooter(25), MathJoyas(26)
// Mobile Apps: Repeat(3), AlertsApp(4), RackTrack(6), Timerin(7), CalenSport(9)
// Web: GranCanariaOfflineMap(12), EduRestas(16), EduSumas(17), EduMulti(18), EduIngles(19), TestYa(27)
// AI: CancerClassifier(13), PeopleDetection(14), PeopleSegmentation(15), LLMWebSocket(20), QuizAI(21), AndroidPeopleDetection(22), AndroidNureonAI(23), AndroidNureonAIPlus(24)
export const PROJECT_CATEGORIES = {
  ai: ['cancer_classifier', 'people_detection', 'people_segmentation', 'llm_websocket', 'quiz_ai', 'android_people_detection', 'android_nureonai', 'android_nureonai_plus'],
  mobile: ['repeat', 'alertsapp', 'racktrack', 'timerin', 'calensport'],
  games: ['gameships', 'aircraftwar', 'spermagame', 'espanta_chiringuitos', 'spermgame2', 'master_panic', 'thieveos', 'math_bubble_shooter_multi', 'math_joyas_multi'],
  web: ['gran_canaria_offline_map', 'edu_restas', 'edu_sumas', 'edu_multi', 'edu_ingles', 'testya']
};

// Devuelve la clave de categoria de un proyecto ('ai' | 'mobile' | 'games' | 'web')
// o null si el proyecto no esta clasificado todavia.
export function getProjectCategoryKey(projectId) {
  return Object.keys(PROJECT_CATEGORIES).find(key => PROJECT_CATEGORIES[key].includes(projectId)) || null;
}
